
        import * as module0 from '../images/logo.png'
        const modules = {
            "../images/logo.png": module0,
        };
        export default modules;
      